export default __webpack_public_path__ + "static/media/iconCross.a0e50af8.svg";